const products = [
  {
    id: 1,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "burger",
    isNew: false,
  },
  {
    id: 2,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "vegetarian",
    isNew: true,
  },
  {
    id: 3,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "meal",
    isNew: false,
  },
  {
    id: 4,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "burger",
    isNew: true,
  },
  {
    id: 5,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "vegetarian",
    isNew: false,
  },
  {
    id: 6,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "burger",
    isNew: true,
  },
  {
    id: 7,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "meal",
    isNew: false,
  },
  {
    id: 8,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "vegetarian",
    isNew: true,
  },
  {
    id: 9,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "chicken",
    isNew: false,
  },
  {
    id: 10,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "burger",
    isNew: true,
  },
  {
    id: 11,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "meal",
    isNew: false,
  },
  {
    id: 12,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "burger",
    isNew: true,
  },
  {
    id: 13,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "meal",
    isNew: false,
  },

  {
    id: 14,
    name: "Pork Chop with Apple Chutney",
    price: 150,
    desc: "",
    cat: "chicken",
    isNew: true,
  },
];

export default products;
